<template>
  <Loader :value="promises.fetchOne" :message="$metaInfo.title" class="form-preview">
    <div class="container view">
      <Webcomponent
        v-if="$path('fields.length', item)"
        tag="kvass-form"
        source="https://unpkg.com/@kvass/widgets@latest/dist/kvass-form.js"
        :form-id="item.id"
        :title="item.title"
        :description="item.description"
        :fields="fields"
        :settings="JSON.stringify($path('settings', item) || {})"
        :privacy-prefix="$path('reference.url', item)"
        :mapbox-theme="mapboxConfig.theme"
        :mapbox-api-token="mapboxConfig.apiKey"
      />
    </div>
  </Loader>
</template>

<script>
import Card from '@/components/Card'
import { mapState, mapActions } from 'vuex'
import Webcomponent from '@kvass/custom-fields/src/Fields/Webcomponent'

export default {
  props: {
    id: String,
  },

  watch: {
    id: {
      handler(id = '') {
        return this.fetch({ id }).then(() => {
          if (!this.item.id) return this.$router.replace({ name: 'notfound' })
        })
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState('Form', ['item', 'promises']),
    fields() {
      const fields = this.$path('fields', this.item) || []
      return JSON.stringify(fields)
    },
    mapboxConfig() {
      return {
        apiKey: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
        theme: process.env.VUE_APP_MAPBOX_STYLE,
      }
    },
  },
  methods: {
    ...mapActions('Form', ['fetch']),
  },

  created() {},
  metaInfo() {
    return {
      title: this.$path('item.title'),
    }
  },
  components: {
    Card,
    Webcomponent,
  },
}
</script>

<style lang="scss">
.form-preview {
  background-color: $background-grey;

  &__form {
    margin: 0 auto;
    max-width: 1200px;
  }
}
</style>
